module.exports = __webpack_public_path__ + "media/pdf/smp/Muster_SCHUFA-Kompaktauskunft-23ff3075f7b6ff7a1bb8137c098ee0d6.pdf";